import { t } from "i18next";

export enum LifeCycleStage {
  Design = "Design",
  DataCollection = "DataCollection",
  Coding = "Coding",
  Review = "Review",
  Completed = "Completed",
}

export const tLifeCycleStage = (value: LifeCycleStage) =>
  t(`shared:lifeCycleStage.${value}`);
